module.exports = __webpack_public_path__ + "img/capitalboxflex.215720c.png";